import { useCallback } from "react";
import OwnerAlertCard from "./OwnerAlertCard";

export default function OwnerAlertsPanel({ alerts, loading, onIgnore, onResolve, onRefresh }) {
  const handleIgnore = useCallback(
    async (alertId) => {
      await onIgnore(alertId);
    },
    [onIgnore]
  );

  const handleResolve = useCallback(
    async (alertId) => {
      await onResolve(alertId);
    },
    [onResolve]
  );

  if (loading) {
    return (
      <div className="py-12 text-center text-gray-500 text-sm">A carregar alertas...</div>
    );
  }

  const active = alerts.filter((a) => !["ignored", "resolved"].includes(a.status));
  const archived = alerts.filter((a) => ["ignored", "resolved"].includes(a.status));

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-semibold text-gray-800">
          Alertas de Performance
          {active.length > 0 && (
            <span className="ml-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
              {active.length}
            </span>
          )}
        </h2>
        <button
          onClick={onRefresh}
          className="text-xs text-gray-500 hover:text-gray-800 underline"
        >
          Atualizar
        </button>
      </div>

      {active.length === 0 && archived.length === 0 && (
        <div className="py-10 text-center text-gray-400 text-sm">
          Nenhum alerta no momento. O sistema está a monitorizar o seu restaurante.
        </div>
      )}

      {active.map((alert) => (
        <OwnerAlertCard
          key={alert.id}
          alert={alert}
          onIgnore={handleIgnore}
          onResolve={handleResolve}
        />
      ))}

      {archived.length > 0 && (
        <details className="mt-4">
          <summary className="text-xs text-gray-400 cursor-pointer hover:text-gray-600 mb-2">
            Arquivados ({archived.length})
          </summary>
          {archived.map((alert) => (
            <OwnerAlertCard
              key={alert.id}
              alert={alert}
              onIgnore={handleIgnore}
              onResolve={handleResolve}
            />
          ))}
        </details>
      )}
    </div>
  );
}
